<template>
  <!-- <Toast /> -->
  <ErrorModal />

  <div class="card-container storeName">

    <div class="flex">
      <h2 class="header">{{storename}}</h2>
      <!-- <h2 class="header">Protractor Demo Store <span class="pi pi-shop" style="width:2rem;height:2rem;"></span></h2> -->
    </div>

    <div class="flex customer">

      <Dropdown v-model="selectedPeriod" :options="periods" optionLabel="name" placeholder="Select Period" @change="setPeriodDates" />
      <Calendar v-model="dates" selectionMode="range" placeholder="Select Date Range" @update:modelValue="searchSummaryReport" id="calendar-input"/>
      <div></div>
      <Button type="button" label="Set" :loading="searchLoad" @click="searchSummaryReport" class="p-button p-component p-button p-component p-button-rounded btn-secondary sml mr-2" style="display:none;"/>
      
    </div>

  </div>
  <div class="container empty" v-if="loading">
    <span>Retrieving Data <i class="pi pi-spin pi-spinner" style="font-size: 3rem"></i></span>
  </div>
  <div class="container" v-if="!loading">

    <div class="wo-details">
      <p class="customer">
        <!-- <span class="mr-2"><strong>Open Work Orders:</strong>[value]</span> -->
        <span class="mr-2"><strong>Invoice Count:</strong>{{ invoiceTotal.CurrentAmount }}</span>
      </p>
    </div>

    <Panel id="profit" toggleable style="margin-bottom: 1rem;"> <!-- PROFIT -->

      <template #header>
        <div class="flex align-items-center gap-2">
          <!-- <Avatar image="https://primefaces.org/cdn/primevue/images/avatar/amyelsner.png" size="large" shape="circle" /> -->
          <span class="mr-2">PROFIT</span>
        </div>
      </template>

      <!-- <template #footer>
        <div class="flex flex-wrap align-items-center justify-content-between gap-3">
          <div class="flex align-items-center gap-2">
            <Button icon="pi pi-user" rounded text></Button>
            <Button icon="pi pi-bookmark" severity="secondary" rounded text></Button>
          </div>
          <span class="p-text-secondary">Updated 2 hours ago</span>
        </div>
      </template> -->

      <template #icons>
        <!-- <button class="p-panel-header-icon p-link mr-1" @click="toggle">
          <span class="pi pi-cog"></span>
        </button> -->
        <Menu ref="menu" id="config_menu" :model="items" popup />
      </template>

      <div class="flex flex-wrap flex-row items">

        <div class="item">

          <div class="title">
            <h1 style="margin:0;">Profit</h1>
          </div>

          <div class="flex flex-wrap flex-row info">

            <div class="values">
              <div class="content">
                <h4>Gross Profit $ <span v-tooltip="{ value: 'Gross Profit (GP$)', autoHide: false }" class="pi pi-info-circle"></span></h4>
                <p class="value cond">{{ setDenomination(grossProfit.CurrentAmount) }} 
                    <span v-tooltip="{ value: grossProfit.Difference, hideDelay: 10000 }"
                        :class="setStatusClass(grossProfit.Status)" style="font-size: 1.75rem">
                    </span>
                </p>
              </div>
            </div>
            <div class="values">
              <div class="content">
                <h4>Gross Profit % <span v-tooltip="{ value: 'Gross Profit % (GP%)', autoHide: false }" class="pi pi-info-circle"></span></h4>
                <p class="value cond">{{ setDenomination(grossProfitPercentage.CurrentAmount) }} % 
                    <span v-tooltip="{ value: grossProfitPercentage.Difference, autoHide: false }" 
                        :class="setStatusClass(grossProfitPercentage.Status)" style="font-size: 1.75rem">
                    </span>
                </p>
              </div>
            </div>

          </div>

        </div>

      </div>

    </Panel>

    <Panel id="salesandrevenue" toggleable style="margin-bottom: 1rem;"> <!-- SALES & REVENUE -->

      <template #header>
        <div class="flex align-items-center gap-2">
          <!-- <Avatar image="https://primefaces.org/cdn/primevue/images/avatar/amyelsner.png" size="large" shape="circle" /> -->
          <!-- <p><span class="mr-2">SALES & REVENUE</span>|<span class="ml-2">Q1, 2023</span></p> -->
          <p><span class="mr-2">SALES & REVENUE</span></p>
        </div>
      </template>

      <!-- <template #footer>
        <div class="flex flex-wrap align-items-center justify-content-between gap-3">
          <div class="flex align-items-center gap-2">
            <Button icon="pi pi-user" rounded text></Button>
            <Button icon="pi pi-bookmark" severity="secondary" rounded text></Button>
          </div>
          <span class="p-text-secondary">Updated 2 hours ago</span>
        </div>
      </template> -->

      <template #icons>
        <!-- <button class="p-panel-header-icon p-link mr-1" @click="settings = true">
          <span class="pi pi-cog"></span>
        </button> -->
        <Menu ref="menu" id="config_menu" :model="items" popup />
      </template>

      <div class="flex flex-wrap flex-row items">

        <div class="item"> <!-- SALES -->

          <div class="title">
            <h1 style="margin:0;">Sales</h1>
          </div>

          <TabView>

            <TabPanel header="Chart">
              <p class="title">Sales</p>

              <div class="flex flex-1 justify-content-center chart doughnut">
                <Chart type="doughnut" :data="salesPieData" :options="pieOptions" />
                <p class="center value cond">${{ setDenomination(tireSales.CurrentAmount + partsSales.CurrentAmount + laborSales.CurrentAmount + subletSales.CurrentAmount) }}</p>
              </div>
            </TabPanel>

            <TabPanel header="Values">
              <div class="flex flex-wrap flex-row info values-tab">

                <div class="values">
                  <div class="content">
                    <h4>Average Invoice <span v-if="averageInvoice.Explanation" v-tooltip="{ value: averageInvoice.Explanation, autoHide: false }" class="pi pi-info-circle"></span></h4>
                    <p class="value cond">${{ setDenomination(averageInvoice.CurrentAmount) }}
                        <span v-tooltip="{ value: averageInvoice.Difference, autoHide: false }" 
                            :class="setStatusClass(averageInvoice.Status)" style="font-size: 1.75rem">
                        </span>
                    </p>
                  </div>
                </div>
                <div class="values">
                  <div class="content">
                    <h4>Net Total <span v-if="netTotal.Explanation" v-tooltip="{ value: netTotal.Explanation, autoHide: false }" class="pi pi-info-circle"></span></h4>
                    <p class="value cond">${{ setDenomination(netTotal.CurrentAmount) }}
                        <span v-tooltip="{ value: netTotal.Difference, autoHide: false }" 
                            :class="setStatusClass(netTotal.Status)" style="font-size: 1.75rem">
                        </span>
                    </p>
                  </div>
                </div>

                <div class="values">
                  <div class="content">
                    <h4>Tire Sales <span v-if="tireSales.Explanation" v-tooltip="{ value: tireSales.Explanation, autoHide: false }" class="pi pi-info-circle"></span></h4>
                    <p class="value cond">${{ setDenomination(tireSales.CurrentAmount) }}
                        <span v-tooltip="{ value: tireSales.Difference, autoHide: false }" 
                            :class="setStatusClass(tireSales.Status)" style="font-size: 1.75rem">
                        </span>
                    </p>
                  </div>
                </div>
                <div class="values">
                  <div class="content">
                    <h4>Parts Sales <span v-if="partsSales.Explanation" v-tooltip="{ value: partsSales.Explanation, autoHide: false }" class="pi pi-info-circle"></span></h4>
                    <p class="value cond">${{ setDenomination(partsSales.CurrentAmount) }}
                        <span v-tooltip="{ value: partsSales.Difference, autoHide: false }" 
                            :class="setStatusClass(partsSales.Status)" style="font-size: 1.75rem">
                        </span>
                    </p>
                  </div>
                </div>
                <div class="values">
                  <div class="content">
                    <h4>Labor Sales <span v-if="laborSales.Explanation" v-tooltip="{ value: laborSales.Explanation, autoHide: false }" class="pi pi-info-circle"></span></h4>
                    <p class="value cond">${{ setDenomination(laborSales.CurrentAmount) }}
                        <span v-tooltip="{ value: laborSales.Difference, autoHide: false }" 
                            :class="setStatusClass(laborSales.Status)" style="font-size: 1.75rem">
                        </span>
                    </p>
                  </div>
                </div>
                <div class="values">
                  <div class="content">
                    <h4>Sublet Sales <span v-if="subletSales.Explanation" v-tooltip="{ value: subletSales.Explanation, autoHide: false }" class="pi pi-info-circle"></span></h4>
                    <p class="value cond">${{ setDenomination(subletSales.CurrentAmount) }}
                        <span v-tooltip="{ value: subletSales.Difference, autoHide: false }" 
                            :class="setStatusClass(subletSales.Status)" style="font-size: 1.75rem">
                        </span>
                    </p>
                  </div>
                </div>
                <div class="values">
                  <div class="content">
                    <h4>Tire Count <span v-if="tireCount.Explanation" v-tooltip="{ value: tireCount.Explanation, autoHide: false }" class="pi pi-info-circle"></span></h4>
                    <p class="value cond">{{ tireCount.CurrentAmount }}
                        <span v-tooltip="{ value: tireCount.Difference, autoHide: false }" 
                            :class="setStatusClass(tireCount.Status)" style="font-size: 1.75rem">
                        </span>
                    </p>
                  </div>
                </div>
    
              </div>
            </TabPanel>

          </TabView>

        </div>

        <div class="item"> <!-- REVENUE -->

          <div class="title">
            <h1 style="margin:0;">Revenue</h1>
          </div>

          <TabView>

            <TabPanel header="Chart">
              <p class="title">Revenue Total</p>

              <div class="flex flex-1 justify-content-center chart doughnut">
                <Chart type="doughnut" :data="revenuePieData" :options="revenueOptions" />
                <p class="center value cond">${{ setDenomination(revenueTotal.CurrentAmount + taxes.CurrentAmount + otherCharges.CurrentAmount) }}</p>
              </div>
            </TabPanel>

            <TabPanel header="Values">
              <div class="flex flex-wrap flex-row info">

                <div class="flex flex-wrap flex-row info values-tab">
                  <div class="values">
                    <div class="content">
                      <h4>Revenue Total <span v-if="revenueTotal.Explanation" v-tooltip="{ value: revenueTotal.Explanation, autoHide: false }" class="pi pi-info-circle"></span></h4>
                      <p class="value cond">${{ setDenomination(revenueTotal.CurrentAmount) }}
                        <span v-tooltip="{ value: revenueTotal.Difference, autoHide: false }" 
                            :class="setStatusClass(revenueTotal.Status)" style="font-size: 1.75rem">
                        </span>
                      </p>
                    </div>
                  </div>
                  <div class="values">
                    <div class="content">
                      <h4>Taxes <span v-if="taxes.Explanation" v-tooltip="{ value: taxes.Explanation, autoHide: false }" class="pi pi-info-circle"></span></h4>
                      <p class="value cond">${{ setDenomination(taxes.CurrentAmount) }}
                        <span v-tooltip="{ value: taxes.Difference, autoHide: false }" 
                            :class="setStatusClass(taxes.Status)" style="font-size: 1.75rem">
                        </span>
                      </p>
                    </div>
                  </div>
                  <div class="values">
                    <div class="content">
                      <h4>Net Total <span v-if="netTotal.Explanation" v-tooltip="{ value: netTotal.Explanation, autoHide: false }" class="pi pi-info-circle"></span></h4>
                      <p class="value cond">${{ setDenomination(netTotal.CurrentAmount) }}
                        <span v-tooltip="{ value: netTotal.Difference, autoHide: false }" 
                            :class="setStatusClass(netTotal.Status)" style="font-size: 1.75rem">
                        </span>
                      </p>
                    </div>
                  </div>
                  <div class="values">
                    <div class="content">
                      <h4>Other Charges <span v-if="otherCharges.Explanation" v-tooltip="{ value: otherCharges.Explanation, autoHide: false }" class="pi pi-info-circle"></span></h4>
                      <p class="value cond">${{ setDenomination(otherCharges.CurrentAmount) }}
                        <span v-tooltip="{ value: otherCharges.Difference, autoHide: false }" 
                            :class="setStatusClass(otherCharges.Status)" style="font-size: 1.75rem">
                        </span>
                      </p>
                    </div>
                  </div>
      
                </div>

              </div>
            </TabPanel>

          </TabView>

        </div>

      </div>

    </Panel>

    <Panel id="opportunity" toggleable style="margin-bottom: 1rem;"> <!-- OPPORTUNITY -->

      <template #header>
        <div class="flex align-items-center gap-2">
          <p><span class="mr-2">OPPORTUNITY</span></p>
        </div>
      </template>

      <template #icons>
        <!-- <button class="p-panel-header-icon p-link mr-1" @click="toggle">
          <span class="pi pi-cog"></span>
        </button> -->
        <Menu ref="menu" id="config_menu" :model="items" popup />
      </template>

      <div class="flex flex-wrap flex-row items"> <!-- OPPORTUNITY -->

        <div class="item"> <!-- VALUES -->
  
          <div class="title">
            <h1 style="margin:0;">Opportunity</h1>
          </div>

          <TabView>

            <TabPanel header="Charts">

              <div class="flex flex-wrap flex-row items">

                <div class="item"> <!-- OPPORTUNITY -->

                  <p class="title">Total Opportunity</p>
          
                  <div class="flex flex-1 justify-content-center chart doughnut">
                    <Chart type="doughnut" :data="totalOppData" :options="totalOppOptions" :legend="bottom" />
                    <p class="center value cond">${{ setDenomination(revenueTotal.CurrentAmount + deferredTotal.CurrentAmount) }}</p>
                  </div>
          
                </div>
          
                <div class="item"> <!-- DEFERRED -->
        
                  <p class="title">Hours Presented</p>
          
                  <div class="flex flex-1 justify-content-center chart doughnut">
                    <Chart type="doughnut" :data="hoursData" :options="hoursOptions" />
                    <p class="center value cond">{{ hoursPresented.CurrentAmount }}</p>
                  </div>
          
                </div>

              </div>

            </TabPanel>
        
            <TabPanel header="Values">
              
              <div class="flex flex-wrap flex-row info values-tab"> <!-- OPPORTUNITY -->
  
                <div class="values" style="order:1;">
                  <div class="content">
                    <h4>Total Opportunity <span v-if="totalOpportunity.Explanation" v-tooltip="{ value: totalOpportunity.Explanation, autoHide: false }" class="pi pi-info-circle"></span></h4>
                    <p class="value cond">${{ setDenomination(totalOpportunity.CurrentAmount) }}
                        <span v-tooltip="{ value: totalOpportunity.Difference, autoHide: false }" 
                            :class="setStatusClass(totalOpportunity.Status)" style="font-size: 1.75rem">
                        </span>
                    </p>
                  </div>
                </div>
                <div class="values" style="order:3;">
                  <div class="content">
                    <h4>Average Opportunity <span v-if="averageOpportunity.Explanation" v-tooltip="{ value: averageOpportunity.Explanation, autoHide: false }" class="pi pi-info-circle"></span></h4>
                    <p class="value cond">${{ setDenomination(averageOpportunity.CurrentAmount) }}
                        <span v-tooltip="{ value: averageOpportunity.Difference, autoHide: false }" 
                            :class="setStatusClass(averageOpportunity.Status)" style="font-size: 1.75rem">
                        </span>
                    </p>
                  </div>
                </div>
                <div class="values" style="order:5;">
                  <div class="content">
                    <h4>Closing Ratio <span v-if="closingRatio.Explanation" v-tooltip="{ value: closingRatio.Explanation, autoHide: false }" class="pi pi-info-circle"></span></h4>
                    <p class="value cond">{{ setDenomination(closingRatio.CurrentAmount) }} %
                        <span v-tooltip="{ value: closingRatio.Difference, autoHide: false }" 
                            :class="setStatusClass(closingRatio.Status)" style="font-size: 1.75rem">
                        </span>
                    </p>
                  </div>
                </div>
      
                <div class="values" style="order:2;">
                  <div class="content">
                    <h4>Deferred Total <span v-if="deferredTotal.Explanation" v-tooltip="{ value: deferredTotal.Explanation, autoHide: false }" class="pi pi-info-circle"></span></h4>
                    <p class="value cond">${{ setDenomination(deferredTotal.CurrentAmount) }}
                        <span v-tooltip="{ value: deferredTotal.Difference, autoHide: false }" 
                            :class="setStatusClass(deferredTotal.Status)" style="font-size: 1.75rem">
                        </span>
                    </p>
                  </div>
                </div>
                <div class="values" style="order:4;">
                  <div class="content">
                    <h4>Deferred Average <span v-if="deferredAverage.Explanation" v-tooltip="{ value: deferredAverage.Explanation, autoHide: false }" class="pi pi-info-circle"></span></h4>
                    <p class="value cond">${{ setDenomination(deferredAverage.CurrentAmount) }}
                        <span v-tooltip="{ value: deferredAverage.Difference, autoHide: false }" 
                            :class="setStatusClass(deferredAverage.Status)" style="font-size: 1.75rem">
                        </span>
                    </p>
                  </div>
                </div>
                <div class="values" style="order:6;">
                  <div class="content">
                    <h4>Deferred Hours <span v-if="deferredHours.Explanation" v-tooltip="{ value: deferredHours.Explanation, autoHide: false }" class="pi pi-info-circle"></span></h4>
                    <p class="value cond">{{ deferredHours.CurrentAmount }}
                        <span v-tooltip="{ value: deferredHours.Difference, autoHide: false }" 
                            :class="setStatusClass(deferredHours.Status)" style="font-size: 1.75rem">
                        </span>
                    </p>
                  </div>
                </div>
      
              </div>

            </TabPanel>
        
          </TabView>
  
        </div>
  
      </div>

    </Panel>

    <Panel id="labour" toggleable> <!-- LABOR -->

      <template #header>
        <div class="flex align-items-center gap-2">
          <!-- <Avatar image="https://primefaces.org/cdn/primevue/images/avatar/amyelsner.png" size="large" shape="circle" /> -->
          <span class="mr-2">LABOR</span>
        </div>
      </template>

      <!-- <template #footer>
        <div class="flex flex-wrap align-items-center justify-content-between gap-3">
          <div class="flex align-items-center gap-2">
            <Button icon="pi pi-user" rounded text></Button>
            <Button icon="pi pi-bookmark" severity="secondary" rounded text></Button>
          </div>
          <span class="p-text-secondary">Updated 2 hours ago</span>
        </div>
      </template> -->

      <template #icons>
        <!-- <button class="p-panel-header-icon p-link mr-1" @click="toggle">
          <span class="pi pi-cog"></span>
        </button> -->
        <Menu ref="menu" id="config_menu" :model="items" popup />
      </template>

      <div class="flex flex-wrap flex-row items">

        <div class="item">

          <div class="title">
            <h1 style="margin:0;">Labor</h1>
          </div>

          <div class="flex flex-wrap flex-row info">

            <div class="values">
              <div class="content">
                <h4>Labor Sales <span v-if="laborSales.Explanation" v-tooltip="{ value: laborSales.Explanation, autoHide: false }" class="pi pi-info-circle"></span></h4>
                <p class="value cond">{{ setDenomination(laborSales.CurrentAmount) }}
                    <span v-tooltip="{ value: laborSales.Difference, autoHide: false }" 
                        :class="setStatusClass(laborSales.Status)" style="font-size: 1.75rem">
                    </span>
                </p>
              </div>
            </div>
            <div class="values">
              <div class="content">
                <h4>Average Hours Billed <span v-if="averageHoursBilled.Explanation" v-tooltip="{ value: averageHoursBilled.Explanation, autoHide: false }" class="pi pi-info-circle"></span></h4>
                <p class="value cond">{{ averageHoursBilled.CurrentAmount }} %
                    <span v-tooltip="{ value: averageHoursBilled.Difference, autoHide: false }" 
                        :class="setStatusClass(averageHoursBilled.Status)" style="font-size: 1.75rem">
                    </span>
                </p>
              </div>
            </div>
            <div class="values">
              <div class="content">
                <h4>Effective Labor Rate <span v-if="effectiveLaborRate.Explanation" v-tooltip="{ value: effectiveLaborRate.Explanation, autoHide: false }" class="pi pi-info-circle"></span></h4>
                <p class="value cond">${{ setDenomination(effectiveLaborRate.CurrentAmount) }}
                    <span v-tooltip="{ value: effectiveLaborRate.Difference, autoHide: false }" 
                        :class="setStatusClass(effectiveLaborRate.Status)" style="font-size: 1.75rem">
                    </span>
                </p>
              </div>
            </div>
          </div>

        </div>

    </div>

    </Panel>

    <Sidebar v-model:visible="settings" header="Sidebar" position="right">

      <h3>Sales & Revenue Settings</h3>

      <div class="field">
        
        <div class="flex justify-content-center">
          <div class="flex-auto gap-2">
            <label for="viewDefault" style="display: block; height: 2rem;">Default View:</label> 
            <SelectButton v-model="defaultView" :options="defaultOptions" id="viewDefault" aria-labelledby="basic" />
          </div>
        </div>
      </div>

      <div class="confirm p-sidebar-close">
          <Button label="Save" class="p-button p-component p-button-rounded btn-secondary" />
      </div>

    </Sidebar>

  </div>

</template>

<script lang="ts" setup>
import Chart from 'primevue/chart';
import { ref, onMounted } from "vue";
import Sidebar from 'primevue/sidebar';
import SelectButton from 'primevue/selectbutton';
import { useAuth0 } from "@auth0/auth0-vue";
import ErrorModal from './ErrorModal.vue';
import { openErrorModal } from '@/composables/useErrorLog';
import moment from 'moment';
import { useStore } from 'vuex';

const auth0 = useAuth0();
const loading = ref(true);
const searchLoad = ref(false);
const summaryreport = ref();
const invoiceTotal = ref([]);
const grossProfit = ref([]);
const grossProfitPercentage = ref([]);

const partsSales = ref([]);
const tireSales = ref([]);
const laborSales = ref([]);
const subletSales = ref([]);
const netTotal = ref([]);
const averageInvoice = ref([]);
const tireCount = ref([]);

const revenueTotal = ref([]);
const taxes = ref([]);
const otherCharges = ref([]);

const totalOpportunity = ref([]);
const averageOpportunity = ref([]);
const closingRatio = ref([]);
const deferredTotal = ref([]);
const deferredAverage = ref([]);
const deferredHours = ref([]);
const hoursSold = ref([]);
const hoursPresented = ref([]);

const averageHoursBilled = ref([]);
const effectiveLaborRate = ref([]);

const settings = ref(false);
const salesPieData = ref();
const pieOptions = ref();
const revenuePieData = ref();
const revenueOptions = ref();
const totalOppData = ref();
const totalOppOptions = ref();
const hoursData = ref();
const hoursOptions = ref();
// - Presented [value|hour] % in chart
// - Billed [value|hour] % in chart
// - Sold [value|hour] (same as ‘Billed’?) % in chart
const dates = ref([]);
const defaultView = ref('Chart');
const defaultOptions = ref(['Chart', 'Values']);

const selectedPeriod = ref();
const periods = ref([
    { name: 'Today', code: 'today' },
    { name: 'This Week', code: 'tw' },
    { name: 'This Month', code: 'tm' },
    { name: 'This Quarter', code: 'tq' },
    { name: 'This Year', code: 'ty' },
    { name: 'Yesterday', code: 'yesterday' },
    { name: 'Last Week', code: 'lw' },
    { name: 'Last Month', code: 'lm' },
    { name: 'Last Quarter', code: 'lq' },
    { name: 'Last Year', code: 'ly' },
]);

const storename = ref();
const initialLoad = ref(true);
const store = useStore();

onMounted(async () => {
    storename.value = store.state.storename;
    await searchSummaryReport();
    pieOptions.value = setPieOptions(); // set legends at the bottom of the chart
    revenueOptions.value = setRevenueOptions(); // set legends at the bottom of the chart
    totalOppOptions.value = setTotalOppOptions();
    hoursOptions.value = setHoursOptions();
    initialLoad.value = false;
});

const setSalesPieChart = () => {
    const documentStyle = getComputedStyle(document.body);
    return {
        labels: [' Parts Sales $', ' Tire Sales $', ' Labor Sales $', ' Sublet Sales $'],
        datasets: [
            {
                data: [partsSales.value.CurrentAmount, tireSales.value.CurrentAmount, laborSales.value.CurrentAmount, subletSales.value.CurrentAmount],
                backgroundColor: [documentStyle.getPropertyValue('--cyan-500'), documentStyle.getPropertyValue('--orange-500'), documentStyle.getPropertyValue('--gray-500'), documentStyle.getPropertyValue('--green-500')],
                hoverBackgroundColor: [documentStyle.getPropertyValue('--cyan-400'), documentStyle.getPropertyValue('--orange-400'), documentStyle.getPropertyValue('--gray-400'), documentStyle.getPropertyValue('--green-400')]
            }
        ]
    };
};
  
const setPieOptions = () => {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');

    return {
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    usePointStyle: true,
                    color: textColor,
                }
            }
        }
    };
}

const setRevenuePieChart = () => {
    const documentStyle = getComputedStyle(document.body);
    return {
        labels: [' Revenue Total $', ' Taxes $', ' Other Charges $'],
        datasets: [
            {
                data: [revenueTotal.value.CurrentAmount, taxes.value.CurrentAmount, otherCharges.value.CurrentAmount],
                backgroundColor: [documentStyle.getPropertyValue('--cyan-500'), documentStyle.getPropertyValue('--orange-500'), documentStyle.getPropertyValue('--gray-500'), documentStyle.getPropertyValue('--green-500')],
                hoverBackgroundColor: [documentStyle.getPropertyValue('--cyan-400'), documentStyle.getPropertyValue('--orange-400'), documentStyle.getPropertyValue('--gray-400'), documentStyle.getPropertyValue('--green-400')]
            }
        ]
    };
};
  
const setRevenueOptions = () => {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');

    return {
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    usePointStyle: true,
                    color: textColor,
                }
            }
        }
    };
}

const setTotalOppPieChart = () => {
    const documentStyle = getComputedStyle(document.body);

    return {
        labels: [' Revenue Total $', ' Deferred Total $'],
        datasets: [
            {
                data: [revenueTotal.value.CurrentAmount, deferredTotal.value.CurrentAmount],
                backgroundColor: [documentStyle.getPropertyValue('--cyan-500'), documentStyle.getPropertyValue('--orange-500'), documentStyle.getPropertyValue('--gray-500'), documentStyle.getPropertyValue('--green-500')],
                hoverBackgroundColor: [documentStyle.getPropertyValue('--cyan-400'), documentStyle.getPropertyValue('--orange-400'), documentStyle.getPropertyValue('--gray-400'), documentStyle.getPropertyValue('--green-400')]
            }
        ]
    };
};

const setTotalOppOptions = () => {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');

    return {
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    usePointStyle: true,
                    color: textColor,
                }
            }
        }
    };
}

const setHoursPieChart = () => {
    const documentStyle = getComputedStyle(document.body);

    return {
        labels: [' Hours Sold', ' Deferred Hours'],
        datasets: [
            {
                data: [hoursSold.value.CurrentAmount, deferredHours.value.CurrentAmount],
                backgroundColor: [documentStyle.getPropertyValue('--cyan-500'), documentStyle.getPropertyValue('--orange-500'), documentStyle.getPropertyValue('--gray-500'), documentStyle.getPropertyValue('--green-500')],
                hoverBackgroundColor: [documentStyle.getPropertyValue('--cyan-400'), documentStyle.getPropertyValue('--orange-400'), documentStyle.getPropertyValue('--gray-400'), documentStyle.getPropertyValue('--green-400')]
            }
        ]
    };
};

const setHoursOptions = () => {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');

    return {
        plugins: {
            title: {
                text: 'Total Opportunity',
            },
            legend: {
                position: 'bottom',
                labels: {
                    usePointStyle: true,
                    color: textColor,
                }
            }
        }
    };
}

const searchSummaryReport = async () => {
    if (initialLoad.value === true) {
      const today = moment();
      const startDate = today.clone().startOf('month').format('MM/DD/YYYY');
      const endDate = today.clone().endOf('month').format('MM/DD/YYYY');
      const calendarElement = document.getElementById('calendar-input');
      const inputElement = calendarElement?.querySelector('input');
      dates.value[0] = startDate;
      dates.value[1] = endDate;
      selectedPeriod.value = periods.value[2]; //This Month
      if (inputElement) {
        inputElement.value = `${startDate} - ${endDate}`;
      }
    }

    if (dates.value[0] && dates.value[1]) {
        const startDate = moment(dates.value[0]).format('MM/DD/YYYY');
        const endDate = moment(dates.value[1]).format('MM/DD/YYYY');
        loading.value = true;
        searchLoad.value = true;
        await getSummaryReport(startDate, endDate);
        loading.value = false;
        searchLoad.value = false;
    }
}

const getSummaryReport = async (startDate, endDate) => {
    const storeid = store.state.storeid;
    const WOurl = `${process.env.VUE_APP_NODEJS_BASE_URL}reporting/salessummaryreport/${storeid}?startDate=${startDate}&endDate=${endDate}`;
    try {
        const accessToken = await auth0.getAccessTokenSilently();
        const response = await fetch(WOurl, {
            headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
            'Accept-Encoding': 'gzip'
            }
        });

        const data = await response.json();
        if (response.status > 400) {
            throw new Error(JSON.stringify(data.error));
        }
        summaryreport.value = data.message;
        setCurrentCount();
        setProfitData();
        setSalesandRevenueData();
        setTotalOppandHoursData();
        setLaborData();
        loading.value = false;
    } catch (e) {
        openErrorModal(e.message);
    }
}

const setCurrentCount = () => {
    invoiceTotal.value = summaryreport.value.find(item => item.Name === "InvoiceTotal");
}

const setProfitData = () => {
    grossProfit.value = summaryreport.value.find(item => item.Name === "GrossProfit");
    grossProfitPercentage.value = summaryreport.value.find(item => item.Name === "GrossProfitPercentage");
    grossProfitPercentage.value.CurrentAmount *= 100;
}

const setSalesandRevenueData = () => {
    // Sales
    partsSales.value = summaryreport.value.find(item => item.Name === "PartsSales");
    tireSales.value = summaryreport.value.find(item => item.Name === "TireSales");
    laborSales.value = summaryreport.value.find(item => item.Name === "LaborSales");
    subletSales.value = summaryreport.value.find(item => item.Name === "SubletSales");
    netTotal.value = summaryreport.value.find(item => item.Name === "NetTotal");
    averageInvoice.value = summaryreport.value.find(item => item.Name === "AverageInvoice");
    tireCount.value = summaryreport.value.find(item => item.Name === "TireCount");

    // Revenue
    revenueTotal.value = summaryreport.value.find(item => item.Name === "RevenueTotal");
    taxes.value = summaryreport.value.find(item => item.Name === "Taxes");
    otherCharges.value = summaryreport.value.find(item => item.Name === "OtherCharges");

    salesPieData.value = setSalesPieChart();
    revenuePieData.value = setRevenuePieChart();
}

const setTotalOppandHoursData = () => {
    totalOpportunity.value = summaryreport.value.find(item => item.Name === "TotalOpportunity");
    averageOpportunity.value = summaryreport.value.find(item => item.Name === "AverageOpportunity");
    closingRatio.value = summaryreport.value.find(item => item.Name === "ClosingRatio");
    closingRatio.value.CurrentAmount *= 100;
    deferredTotal.value = summaryreport.value.find(item => item.Name === "DeferredTotal");
    deferredAverage.value = summaryreport.value.find(item => item.Name === "DeferredAverage");
    deferredHours.value = summaryreport.value.find(item => item.Name === "DeferredHours");
    hoursSold.value = summaryreport.value.find(item => item.Name === "HoursSold");
    hoursPresented.value = summaryreport.value.find(item => item.Name === "HoursPresented");
    
    totalOppData.value = setTotalOppPieChart();
    hoursData.value = setHoursPieChart();
}

const setLaborData = () => {
    averageHoursBilled.value = summaryreport.value.find(item => item.Name === "AverageHoursBilled");
    effectiveLaborRate.value = summaryreport.value.find(item => item.Name === "EffectiveLaborRate");
}

const setDenomination = (number) => {
    return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 5 });
}

const setStatusClass = (status) => {
    return {
        'pi': true,
        'pi-arrow-circle-up': status === 'Up',
        'pi-arrow-circle-down': status === 'Down',
        'pi-minus-circle': status === 'Equal'
    };
}

const setPeriodDates = async () => {
    const today = moment();
    let startDate, endDate;

    switch (selectedPeriod.value.code) {
        case 'today':
            startDate = endDate = today;
            break;
        case 'yesterday':
            startDate = endDate = today.subtract(1, 'day');
            break;
        case 'tw':
            startDate = today.clone().startOf('week');
            endDate = today.clone().endOf('week');
            break;
        case 'tm':
            startDate = today.clone().startOf('month');
            endDate = today.clone().endOf('month');
            break;
        case 'tq':
            startDate = today.clone().startOf('quarter');
            endDate = today.clone().endOf('quarter');
            break;
        case 'ty':
            startDate = today.clone().startOf('year');
            endDate = today.clone().endOf('year');
            break;
        case 'lw':
            startDate = today.clone().subtract(1, 'week').startOf('week');
            endDate = today.clone().subtract(1, 'week').endOf('week');
            break;
        case 'lm':
            startDate = today.clone().subtract(1, 'month').startOf('month');
            endDate = today.clone().subtract(1, 'month').endOf('month');
            break;
        case 'lq':
            startDate = today.clone().subtract(1, 'quarter').startOf('quarter');
            endDate = today.clone().subtract(1, 'quarter').endOf('quarter');
            break;
        case 'ly':
            startDate = today.clone().subtract(1, 'year').startOf('year');
            endDate = today.clone().subtract(1, 'year').endOf('year');
            break;
    }

    dates.value = [startDate.toDate(), endDate.toDate()];

    await searchSummaryReport();
}
</script>

<style>
  .container.empty {
    text-align: center;
    padding: 5rem;
  }
  .container.empty span {
    font-size: 3rem;
  }
  /* .p-panel.p-component {
    border-radius: 25px !important;
  } */
  /* .p-panel .p-panel-header {
    border-top-left-radius: 25px !important;
    border-top-right-radius: 25px !important;
  } */
  /* .p-panel .p-panel-content {
    border-bottom-left-radius: 25px !important;
    border-bottom-right-radius: 25px !important;
  } */
  .p-dropdown.storeChange.p-dropdown-clearable .p-dropdown-label {
    padding-right: 0.375rem;
  }
  /* .reporting .p-calendar {
    width: 185px !important;
  } */
  .p-calendar .p-inputtext {
    /* flex: 1 1 auto; */
    /* width: 1%; */
    /* border-radius: 50px; */
    height: 35px;
    padding-left: 0.75rem;
    color: #6c757d;
  }
  .p-inputtext {
    color: white;
    /* color: transparent; */
  }
  /* .p-calendar .p-inputtext:enabled:hover {
    border: 2px solid #ced4da;
  } */
  h2.header {
    display: flex;
  }
  .p-dropdown.storeChange {
    background-color: transparent;
    /* border: 1px solid white; */
    /* color: white; */
    /* border-radius: 50px; */
    margin-left: 0.5rem;
    margin-right: 0;
  }
  .p-dropdown.storeChange .p-dropdown-label.p-placeholder {
    /* color: white; */
    padding-left: 0.75rem;
    background-color: transparent !important;
  }
  .p-dropdown.storeChange .p-dropdown-trigger {
    /* background: transparent; */
    /* color: white; */
    width: 1.5rem;
    margin-right: 0.5rem;
    /* border-top-right-radius: 3px; */
    /* border-bottom-right-radius: 3px; */
  }
  .p-tooltip.p-component.p-tooltip-right {
    /* width: 30rem !important; */
    background-color: transparent !important;
  }
  .pi.pi-arrow-circle-up {
    color: limegreen !important;
  }
  .pi.pi-arrow-circle-down {
    color: red !important;
  }
  .p-calendar {
    position: static !important;
    display: block !important;
    max-width: 100%;
  }
  .p-calendar .p-inputtext {
    flex: 1 1 auto;
    width: 100% !important;
  }
  button.p-sidebar-close.p-sidebar-icon.p-link {
    display: block !important;
    padding: 0.5rem !important;
  }
  .p-component-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .p-chart {
    width: 100%;
  }
  .p-chart canvas {
    width: 100% !important;
    height: auto !important;
  }
  .items {
    width: 100%;
    /* margin-bottom: 1rem; */
  }
  .item .title {
    width: 100%;
  }
  .item p.title {
    text-align: center;
    font-size: 1.33rem;
    font-weight: 400;
    margin: 0;
  }
  .items .item .info {
    width: 100%;
  }
  .items .item .info .values .content {
    /* width: 100%; */
    margin: 0;
    /* position: absolute; */
    /* top: 50%; */
    /* transform: translateY(-50%); */
    text-align: left;
    padding: 0;
  }
  .items .item .info .values .content h4 {
    line-height: 80%;
    line-height: 1.2;
    margin: 0;
    padding: 0;
  }
  .items .item .info .values .content h4 span.small {
    font-size: 50%;
    font-weight: 300;
  }
  .items .item .info .values .content p.value {
    /* font-family: 'Roboto Condensed',sans-serif; */
    font-size: 2.25rem;
    font-weight: 500;
    line-height: 1.3;
  }
  .items .item .chart.doughnut {
    position: relative;
  }
  .items .item .chart.doughnut p.center {
    position: absolute;
    text-align: center;
    /* left: 50%; */
    top: 40%;
    font-size: 1.33rem;
    font-weight: 400;
  }
  .items .item .values-tab .values {
    width: 50%;
  }
  .container.no-pad {
    padding-right: 0;
    padding-left: 0;
  }

  button {
    border: none;
    background-color: transparent;
    padding: 1rem;
  }

  .period {
    background-color: #eee;
    color:#000;
    border-radius: 10px;
    padding: 0.5rem 1rem;
    margin-left: 0.5rem;
  }
  .period.selected {
    background-color: #0ea5e9;
    color:#fff
  }

  .p-card {
    box-shadow: none;
    border: none;
  }
  .singles {
    width: 100%;
    flex-grow: 1;
  }
  .singles > div {
    width: 100%;
  }
  .singles > div:first-child {
    margin-left: 0;
  }
  .singles > div:last-child {
    margin-right: 0;
  }
  .p-card .p-card-title {
    font-weight: 500;
    font-size: 1.5rem;
  }
  .p-card-body {
    background-color: white;
  }
  .p-card .p-card-body p.value {
    /* font-family: 'Roboto Condensed', sans-serif; */
    font-size: 2.5rem;
    font-weight: 500;
    text-align: center;
}

  .input-group-text {
    background-color: #cee2fe;
    border: 1px solid #c3dcff;
  }

  .input-group input {
    border: 1px solid #c3dcff;
  }

  .table-bordered thead,
  .table-bordered th {
    border: 1px solid #184b89 !important;
    background-color: #cee2fe;
    font-weight: normal;
  }

  .table-bordered tbody {
    border-top: 1px solid #184b89;
  }

  .table-striped tbody tr:nth-of-type(odd) {
    background-color: #f2f8ff;
  }

  .table-bordered td {
    border: 1px solid #c3dcff;
  }

  .btn-outline {
    border: 1px solid #626262;
    color: #626262;
  }
</style>
